import { DirectionalLight, Sphere, Vector3 } from "three";
import { wallLength } from "../controllers/wall-controllers";
import { Wall } from "../domain";

// These are scratch variables used to avoid generating lots of memory churn
const
    sphere = new Sphere(),
    direction = new Vector3(),
    p = new Vector3(),
    v = new Vector3(),
    points: Vector3[] = [];

export const optimizeDirectionalShadow =
    (light: DirectionalLight, walls: Wall[]) =>
{
    if(walls.length == 0) return new Sphere();

    const
        target = light.target,
        camera = light.shadow.camera;

    getRoomBoundingSphere(walls, sphere);

    const r = sphere.radius;

    target.position.copy(sphere.center);
    light.position.normalize();
    light.position.multiplyScalar(Math.max(1, r));
    light.position.add(sphere.center);

    camera.near = 0;
    camera.far = 2*r;
    camera.top = camera.right = r;
    camera.bottom = camera.left = -r;

    camera.updateWorldMatrix(true, false);
    target.updateWorldMatrix(true, false);

    return sphere;
}

export default optimizeDirectionalShadow;

export const updateShadowCameraBounds = (light: DirectionalLight, sphere: Sphere) =>
{
    const
        target = light.target,
        camera = light.shadow.camera,
        r = sphere.radius;
    target.position.copy(sphere.center);

    camera.near = 0;
    camera.far = 2*r;
    camera.top = camera.right = r;
    camera.bottom = camera.left = -r;

    camera.updateWorldMatrix(true, false);
    target.updateWorldMatrix(true, false);
}

export const getRoomBoundingSphere = (walls: Wall[], sphere: Sphere) => {
    points.length = 0;
    for(const wall of walls) {
        direction.set(
            Math.cos(wall.rotation.y),
            0,
            Math.sin(-wall.rotation.y));
        for(const height of wall.heights) {
            p.copy(wall.position);
            v.copy(direction);
            v.multiplyScalar(height.x);
            p.add(v);
            points.push(p.clone());
            p.y = height.height;
            points.push(p.clone());
        }
        if(wall.showExtension) {
            p.copy(wall.position);
            v.copy(direction);
            v.multiplyScalar(-wall.leftExtension);
            p.add(v);
            points.push(p.clone());

            p.copy(wall.position);
            v.copy(direction);
            v.multiplyScalar(wallLength(wall) + wall.leftExtension + wall.rightExtension);
            p.add(v);
            points.push(p.clone());
        }
    }

    sphere.setFromPoints(points);
}
